const initSidebarSlider = () => {
    if (typeof hl_createSwiper === 'undefined') {
        setTimeout(initSidebarSlider, 200);
        return;
    }

    const swiperEl = document.querySelector('.sidebar-swiper');
    if (swiperEl) {
        hl_createSwiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: {
                nextEl: '.sidebar-custom-slider .swiper-button-next',
                prevEl: '.sidebar-custom-slider .swiper-button-prev',
            },
            pagination: {
                el: '.sidebar-custom-slider .swiper-pagination',
                clickable: true,
            },
        });
    }
};

document.addEventListener('DOMContentLoaded', initSidebarSlider);
